import React from 'react';

export const IconTjek = ({ style = {} }) => (
	<svg
		width="60"
		height="60"
		viewBox="0 0 60 60"
		fill="none"
		style={ style }
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M46.7549 28.5439C46.2655 28.5439 45.8671 28.9423 45.8671 29.4317V50.0744H9.77557V13.9898H39.5338C40.0231 13.9828 40.4216 13.5844 40.4146 13.0951C40.4076 12.6127 40.0161 12.2143 39.5338 12.2143H8.88778C8.39845 12.2143 8 12.6127 8 13.102V50.9691C8 51.4585 8.39845 51.8569 8.88778 51.8569H46.7549C47.2442 51.8569 47.6427 51.4585 47.6427 50.9691V29.4387C47.6427 28.9423 47.2442 28.5439 46.7549 28.5439Z" fill="currentColor" />
		<path d="M52.9963 12.8941C52.9077 10.6535 51.0741 8.91866 48.9065 9.00295C47.8636 9.04509 46.8821 9.51567 46.1732 10.3023C46.1527 10.3234 46.1391 10.3445 46.1255 10.3655L29.0847 33.1293L21.28 24.0547L21.2732 24.0477C19.8077 22.3971 17.3198 22.2777 15.7111 23.7878C14.1229 25.2838 13.9934 27.8053 15.418 29.47L26.1741 41.944C26.9171 42.7939 27.9736 43.2785 29.0779 43.2855H29.0983C30.1958 43.2855 31.2455 42.8079 31.9885 41.9791C32.0021 41.9651 32.0157 41.944 32.0362 41.923L51.9807 15.7808C52.676 14.9941 53.044 13.9546 52.9963 12.8941ZM50.6856 14.5938C50.672 14.6078 50.6583 14.6289 50.6379 14.65L30.7002 40.7851C30.2844 41.2346 29.705 41.4875 29.1052 41.4945H29.0915C28.4781 41.4875 27.885 41.2206 27.4761 40.75L16.7199 28.2759C15.9088 27.3418 15.9906 25.909 16.8971 25.0731C17.7969 24.2443 19.1738 24.3216 19.9849 25.2347L28.4849 35.117C28.8052 35.4893 29.3505 35.5244 29.7118 35.1943C29.7527 35.1591 29.7936 35.117 29.8209 35.0678L47.4751 11.4964C48.3135 10.5903 49.704 10.5552 50.5833 11.4261C51.449 12.276 51.4967 13.6877 50.6856 14.5938Z" fill="currentColor" />
	</svg>
);

export const IconPlus = ({ style = {} }) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		stroke="#92004D"
		strokeWidth="2"
		style={ style }
		className="icon-plus"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M8 0 L8 16" />
		<path d="M0 8 L16 8" />
	</svg>
);

export const IconMinus = ({ style = {} }) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		stroke="#92004D"
		strokeWidth="2"
		style={ style }
		className="icon-plus"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M0 8 L16 8" />
	</svg>
);

export const IconArrow = ({ style = {} }) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		stroke="#92004D"
		fill="none"
		strokeWidth="2"
		style={ style }
		className="icon-arrow"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M5 2 L11 8 L5 14" />
	</svg>
);
